import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../App';
import { Briefcase, FileText, Bell, Settings } from 'lucide-react';

const JobsDashboard = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  // Redirect if doesn't have jobs profile
  React.useEffect(() => {
    if (user && !user.has_jobs_profile) {
      navigate('/jobs/onboarding');
    }
  }, [user, navigate]);

  if (!user?.has_jobs_profile) {
    return null;
  }

  return (
    <div className="min-h-screen bg-muted/30">
      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">GoJobs Dashboard</h1>
          <p className="text-muted-foreground">
            Welcome back, {user.full_name}!
          </p>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <div className="bg-card border rounded-xl p-6">
            <div className="flex items-center justify-between mb-2">
              <h3 className="text-sm font-medium text-muted-foreground">Applications</h3>
              <Briefcase className="w-5 h-5 text-purple-600" />
            </div>
            <p className="text-3xl font-bold">0</p>
            <p className="text-xs text-muted-foreground mt-1">Active applications</p>
          </div>

          <div className="bg-card border rounded-xl p-6">
            <div className="flex items-center justify-between mb-2">
              <h3 className="text-sm font-medium text-muted-foreground">Saved Jobs</h3>
              <FileText className="w-5 h-5 text-purple-600" />
            </div>
            <p className="text-3xl font-bold">0</p>
            <p className="text-xs text-muted-foreground mt-1">Jobs saved</p>
          </div>

          <div className="bg-card border rounded-xl p-6">
            <div className="flex items-center justify-between mb-2">
              <h3 className="text-sm font-medium text-muted-foreground">Interviews</h3>
              <Bell className="w-5 h-5 text-purple-600" />
            </div>
            <p className="text-3xl font-bold">0</p>
            <p className="text-xs text-muted-foreground mt-1">Upcoming interviews</p>
          </div>

          <div className="bg-card border rounded-xl p-6">
            <div className="flex items-center justify-between mb-2">
              <h3 className="text-sm font-medium text-muted-foreground">Profile Views</h3>
              <Settings className="w-5 h-5 text-purple-600" />
            </div>
            <p className="text-3xl font-bold">0</p>
            <p className="text-xs text-muted-foreground mt-1">This month</p>
          </div>
        </div>

        {/* Coming Soon Banner */}
        <div className="bg-gradient-to-r from-purple-600 to-purple-800 text-white rounded-2xl p-8 md:p-12">
          <div className="max-w-2xl">
            <h2 className="text-3xl font-bold mb-4">GoJobs is Coming Soon!</h2>
            <p className="text-lg mb-6 text-purple-100">
              We're working hard to bring you an amazing job search and hiring experience. 
              This dashboard will soon feature:
            </p>
            <ul className="space-y-2 mb-6">
              <li className="flex items-start gap-2">
                <span className="text-purple-300 mt-1">✓</span>
                <span>Job search and filtering</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-purple-300 mt-1">✓</span>
                <span>One-click job applications</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-purple-300 mt-1">✓</span>
                <span>Application tracking</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-purple-300 mt-1">✓</span>
                <span>Resume builder and management</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-purple-300 mt-1">✓</span>
                <span>Direct messaging with employers</span>
              </li>
            </ul>
            <p className="text-purple-100">
              In the meantime, explore GoTradies if you're interested in trades work!
            </p>
            <button
              onClick={() => navigate('/tradies')}
              className="mt-6 px-6 py-3 bg-white text-purple-600 font-semibold rounded-xl hover:bg-purple-50 transition-colors"
            >
              Explore GoTradies
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobsDashboard;
